import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import FloorEditorContainer from '~pages/pms-dashboard/properties/listing-management/gallery-management/floor-plan/components/specific-floor-plan-tab/floor-editor';
import {
  SpecificFloorPlanBlankTip,
  CreateNewFloorButton,
} from '~pages/pms-dashboard/properties/listing-management/gallery-management/floor-plan/components/specific-floor-plan-tab/blank-tips';
import SpecificFloorPlanPhotoCard from '~pages/pms-dashboard/properties/listing-management/gallery-management/floor-plan/components/specific-floor-plan-tab/photo-library';
import GeneralFloorPlanPDFCard from '~pages/pms-dashboard/properties/listing-management/gallery-management/floor-plan/components/general-floor-plan-tab/pdf-library';
const { Panel } = Collapse;
import { pmsEndpoints } from '~settings/endpoints';
import { fetch } from '~actions/shared';
import * as queries from '~settings/pms-queries';
import { uniqBy } from 'lodash';

export default class FloorPlans extends React.Component {
  constructor(props) {
    super(props);
    this.newUnitTypeIdToLinkId = null;
    this.scrollContainer = null;
    this.roomSection = null;
    this.state = {
      property: this.props.property ? this.buildPropertyWithLocalId(this.props.property) : {},
      editingFloorPlans: null,
      generalFloorPlanFileList: this.props.property?.floorPlans?.generalFloorPlanImages,
      specificFloorPlanImageList: [],
    };
  }

  componentDidMount() {
    this.props.onRef(this);
    this.extractSpecificFloorPlanImageList(this.state.property?.floorPlans?.specificFloorPlans);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  buildPropertyWithLocalId = property => {
    return {
      ...property,
      floorPlans: {
        ...property.floorPlans,
        specificFloorPlans: property.floorPlans.specificFloorPlans.map(floor => ({
          ...floor,
          localId: Math.random().toString().replace('0.', ''),
        })),
      },
    };
  };

  extractSpecificFloorPlanImageList = list => {
    const buildingList = {};
    list.map(floor => {
      buildingList[floor.localId] = floor.floorPlanImages;
    });
    this.setState({
      specificFloorPlanImageList: buildingList,
    });
  };

  refetchFloorPlans = slug => {
    fetch({
      endpoint: pmsEndpoints.getPropertyDetail.url(),
      params: queries.getPropertyDetail({ slug }),
      onSuccess: res => {
        if (res?.property) {
          const propertyWithLocalId = this.buildPropertyWithLocalId(res.property);
          this.setState({
            property: propertyWithLocalId,
          });
          this.extractSpecificFloorPlanImageList(
            propertyWithLocalId?.floorPlans?.specificFloorPlans,
          );
        }
      },
      onError: e => {
        if (e && e[0] && e[0].message === 'invalid node id.') {
          message.error(i18n.t('cms.properties.edit.toast.error.property_not_exist'));
        } else {
          message.error(i18n.t('cms.properties.edit.toast.error'));
        }
      },
    });
  };

  handleCloseFloorPlansEditor = () => {
    this.setState({
      editingFloorPlans: null,
    });
  };

  handleFloorPlansEditorOnSuccess = () => {
    this.refetchFloorPlans(this.props.property.slug);
  };

  getUpdateData = () => {
    const specificFloorPlanImageFlattenList = [];
    for (const floorIndex in this.state.specificFloorPlanImageList) {
      const currentFloor = this.state.specificFloorPlanImageList[floorIndex].map(
        (floor, index) => ({ ...floor, position: index }),
      );
      specificFloorPlanImageFlattenList.push(...currentFloor);
    }

    const summaryList = [
      ...(this.state.generalFloorPlanFileList.map((item, index) => ({
        ...item,
        position: index,
      })) || []),
      ...uniqBy(specificFloorPlanImageFlattenList, e => e.id),
    ];
    const updateData = {
      floorPlanImages: summaryList.map(image => ({
        id: image.id,
        category: image.category,
        position: image.position,
      })),
    };
    return updateData;
  };

  handlePhotoCardListUpdate = (list, id) => {
    const newestUpdateList = { ...this.state.specificFloorPlanImageList };
    newestUpdateList[id] = list['property:specific'];
    this.setState({
      specificFloorPlanImageList: newestUpdateList,
    });
  };

  handlePDFCardListUpdate = list => {
    this.setState({
      generalFloorPlanFileList: list,
    });
  };

  render() {
    const { t } = this.props;
    const { property } = this.state;
    const floorPlans = property?.floorPlans || {
      generalFloorPlanImages: [],
      specificFloorPlans: [],
    };
    const { editingFloorPlans } = this.state;
    return (
      <div className="virtual-tour-links">
        <ul className="virtual-tour-links__description">
          <li>
            <span className="virtual-tour-links__label">
              {t('cms:cms.property.listing_management.floor_plan.general.label')}
            </span>
            {t('cms:cms.property.listing_management.floor_plan.general.description')}
          </li>
          <li>
            <span className="virtual-tour-links__label">
              {t('cms:cms.property.listing_management.floor_plan.photo.label')}
            </span>
            {t('cms:cms.property.listing_management.floor_plan.photo.description')}
          </li>
        </ul>
        <Collapse
          onChange={this.onChangeCollapse}
          expandIconPosition="right"
          className="virtual-tour-links__collapse floor-plan-tab__collapse"
          defaultActiveKey={['general', 'specific']}
        >
          <Panel
            header={t('cms:cms.property.listing_management.general_floor_plan.panel')}
            key="general"
          >
            <GeneralFloorPlanPDFCard
              t={t}
              property={this.state.property}
              generalFloorPlanImages={floorPlans.generalFloorPlanImages}
              onUpdateList={this.handlePDFCardListUpdate}
              onRef={node => (this.generalFloorPlanPDFCard = node)}
            />
          </Panel>
          <Panel
            header={t('cms:cms.property.listing_management.specific_floor_plan.panel')}
            key="specific"
          >
            <Choose>
              <When condition={floorPlans.specificFloorPlans.length}>
                <div>
                  <CreateNewFloorButton
                    onClick={() => {
                      this.setState({
                        editingFloorPlans: floorPlans.specificFloorPlans,
                      });
                    }}
                    t={t}
                  />
                  <For each="floor" index="index" of={floorPlans.specificFloorPlans}>
                    <SpecificFloorPlanPhotoCard
                      t={t}
                      key={floor.localId}
                      property={this.state.property}
                      floor={floor}
                      localId={floor.localId}
                      onRef={node => (this.specificFloorPlanPhotoCard = node)}
                      onUpdateList={this.handlePhotoCardListUpdate}
                    />
                  </For>
                </div>
              </When>
              <Otherwise>
                <SpecificFloorPlanBlankTip
                  t={t}
                  onClickOpenModal={() => {
                    this.setState({
                      editingFloorPlans: floorPlans.specificFloorPlans,
                    });
                  }}
                />
              </Otherwise>
            </Choose>
          </Panel>
        </Collapse>
        <If condition={editingFloorPlans}>
          <FloorEditorContainer
            activeModal
            id={this.props.property?.id}
            floorPlans={editingFloorPlans}
            t={t}
            handleCloseModal={this.handleCloseFloorPlansEditor}
            handleOnSuccess={this.handleFloorPlansEditorOnSuccess}
          />
        </If>
      </div>
    );
  }
}

FloorPlans.propTypes = {
  t: PropTypes.func.isRequired,
  property: PropTypes.object,
  onRef: PropTypes.func,
};

FloorPlans.defaultProps = {
  t: () => {},
  property: {},
  onRef: () => {},
};
